<form [formGroup]="form">
  <div class="mb-3 text-muted small">
    <p class="mb-1">
      {{ 'organizations.primiary_user.review_and_approve_text' | translate }}
    </p>
  </div>
  <span>{{ 'organizations.primiary_user.assign_to_organization' | translate }}</span>
  <p-input-group>
    <p-select
      [options]="organizations"
      dataKey="id"
      [formControl]="this.form.controls['organization']"
      [placeholder]="(organizationsLoading ? 'loading' : 'organizations.primiary_user.select_organization') | translate"
      [filter]="true"
      filterBy="name"
      [loading]="organizationsLoading"
    >
      <ng-template let-item pTemplate="selectedItem">
        <div>
          {{ item.name }}
          @if (item.address !== null && item.address !== '') {
            <span class="text-muted">({{ item.address }})</span>
          }
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div>
          {{ item.name }}
          @if (item.address !== null && item.address !== '') {
            <span class="text-muted">({{ item.address }})</span>
          }
        </div>
      </ng-template>
    </p-select>
  </p-input-group>
</form>
<app-error [error]="error"></app-error>
